import React, { useMemo } from 'react';
import styled from 'styled-components';

import ChevronRight from 'components/Icons/ChevronRight';
import colors from 'utils/colors';
import device from 'utils/device';

import { BreadCrumbOption } from '../interfaces';

export type ComponentProps = {
  /**
   * list of all breadCrumb options that ar rendered
   */
  items: BreadCrumbOption[];
};

// https://stackoverflow.com/questions/5766069/exact-notinverse-of-css-media-query
const Wrapper = styled.div<ComponentProps>`
  @media ${device.isTablet}, ${device.isDesktop} {
    display: none !important;
  }

  @media ${device.isMobile} {
    position: relative;
    transform: translateX(0.5px) translateY(1.5px) rotate(180deg);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    overflow: hidden;
    width: 9.5px;
    height: 9.5px;
    padding: 0px;
  }
`;

const Link = styled.a`
  position: relative;
  background: transparent;
  border: none;
  outline-color: ${colors.orange};
  padding: 0;
  padding-top: 1px;
  padding-bottom: 2px;
  padding-left: 7px;
  padding-right: 7px;
  color: ${colors.blueGrey};
  font-weight: normal;
  transition: color 0.15s ease-in-out;

  @media ${device.isDesktop}, ${device.isTablet} {
    display: none;
  }

  :hover,
  :focus {
    color: ${colors.brown};
  }

  .hasLink {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const Text = styled.div`
  position: relative;
  margin-left: 11.5px;
  margin-top: 2px;
`;

const NoLinkTextWrapper = styled.div`
  position: relative;

  @media ${device.isDesktop}, ${device.isTablet} {
    display: none;
  }
`;

const BackButton: React.FC<ComponentProps> = ({ items: breadCrumbs = [] }) => {
  // Find last one has link
  const lastLink = useMemo(() => {
    return breadCrumbs
      .filter(opt => {
        return !!opt.link;
      })
      .pop();
  }, [breadCrumbs]);

  let text: string;
  let link: string;

  if (!lastLink) {
    // Initialize state to the main home link
    text = 'Home';
    link = '/';
  } else {
    text = lastLink.text;
    link = lastLink.link || '';
  }
  return (
    <>
      <Wrapper>
        <ChevronRight />
      </Wrapper>
      {link ? (
        <Link
          className={link ? ' hasLink' : ''}
          href={link}
          aria-hidden={link ? 'true' : 'false'}
          tabIndex={link ? undefined : -1}>
          <Text>Back to {text}</Text>
        </Link>
      ) : (
        <NoLinkTextWrapper>
          <Text>{text}</Text>
        </NoLinkTextWrapper>
      )}
    </>
  );
};

export default BackButton;
